import { AddOns, ItemByMenu, StoreMenu, VisibilitySettings } from '@store/online/menu/menuSliceTypes';
import {
  LocationRequestType,
  ModifierGroup,
  IModifier,
  customerDataResponse,
  OrderDataType,
  TicketDataResponse,
  OrderSource,
  PaymentInfo,
  PaymentType,
  TicketPaymentStatus,
  BusinessType,
  OnlineTicketItemType,
  ILocation,
  RestaurantFinancialConfiguration,
  Table,
  RestaurantCustomer,
  IDealDataResponse,
  UserGiftCard,
  WeekDay,
  DefaultQROrderingType,
  GiftCardSettings,
} from '@zeus/shared';
export interface ItemModifier {
  id: number;
  modifierName: string;
  isOptional: boolean;
  limit: number;
  price: string;
  createdAt: string;
  updatedAt: string;
  isGeneric: boolean;
}

export interface ItemTag {
  id: number;
  tagName: string;
  createdAt?: Date;
  updatedAt?: Date;
  image?: null | string;
  key?: null;
}

export interface ItemAllergen {
  id: number;
  itemId?: number[];
  allergenName: string;
  key: string;
  image: string;
  iconId: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface AllergenDialogMenu {
  id: number;
  name: string;
  image?: string;
}

export interface Category {
  id: number;
  categoryName: string;
  items?: CartItem[];
}

export interface Pictures {
  id: number;
  url: string;
}

export interface MenuData {
  id: number;
  menuName: string;
  menuDescription: string;
  createdAt: string;
  updatedAt: string;
  categories: Category[];
  restaurant: Restaurant;
}

export interface Business {
  id: number;
  businessName: string;
  businessAlias?: string;
}

export interface Restaurant {
  id: number;
  name: string;
  onlineOrder: boolean;
  autoFire: boolean;
  autoFireTimer: {
    minutes: number;
  };
  onlineOrderTimer: {
    hours: number;
    minutes: number;
    seconds: number;
  };
  onlineOrderingSettings: OnlineOrderingSetting;
  financialConfigurations?: RestaurantFinancialConfiguration | null;
  phoneNo?: string;
  latitude?: number;
  longitude?: number;
  business?: BusinessType;
  createdAt: string; // Assuming this is a ISO 8601 formatted date string
  updatedAt: string; // Assuming this is a ISO 8601 formatted date string
  restaurantAlias?: string;
  address?: string;
  image?: string;
  isLoyaltyEnabled?: boolean;
  scheduleOrderFireTime?: number;
}

export interface ApiResponse {
  data: MenuData;
  success: boolean;
  message: string;
}

export interface CartProp {
  cart: Cart | undefined;
}

export enum OrderType {
  All = 'all',
  DineIn = 'dine-in',
  Takeaway = 'take-away',
  Delivery = 'delivery',
  ThirdParty = 'third-party',
}

export interface estimatedTimeObj {
  createdAt: string;
  updatedAt: string;
  day: string;
  endTime: string;
  startTime: string;
  id: number;
  status: string;
  type: string;
}

export interface Item {
  id: number;
  itemName: string;
  itemDescription: string;
  itemPrice: number;
  itemPicture: string | null; // You can change this to the actual picture type
  onlineImage: string;
  landscapeImage: string;
  calories: number;
  quantity: number;
  preparationTime: string;
  stockStatus: string;
  sortOrder: number;
  showOnMenu: boolean;
  showOnline: boolean;
  showPOS: boolean;
  showQR: boolean;
  showThirdParty: boolean;
  posName: string;
  kdsName: string;
  createdAt: string;
  updatedAt: string;
  modifierGroup: ModifierGroup[];
  modifiers: IModifier[];
  tag: Tag[];
  allergen: ItemAllergen[];
  pictures: Pictures[];
  totalLikes: number;
  totalReviews: number;
  discountedPrice: number;
  isDiscount: boolean;
  discountPercentage: number;
  orderedQuantity?: number;
  hasModifier?: boolean;
  addOns?: any[];
  minLimit: number;
  maxLimit: number;
  noMaxLimit: boolean;
  isSpecialRequest: boolean;
  isSettingsVisible?: boolean;
  selectedModifierGroups?: ModifierGroup[];
  optionalModifierGroups?: ModifierGroup[] | null;
  requiredModifierGroups?: ModifierGroup[] | null;
  item?: Item;
  loyaltyId?: number;
  loyaltyName?: string;
  loyaltyTier?: number;
  category: Category[];
  taxAmount?: number;
  taxRate?: number;
  isVisible?: boolean;
}

export interface user {
  // firstName: string;
  // lastName: string;
  name: string;
  email?: string;
  birthdate?: string;
  username: string;
  phoneNumber: string;
  restaurantId: number;
}
export interface Order {
  id: number;
  orderedQuantity: number;
  actualPrice?: number;
  isDiscount: boolean;
  discountPercentage: number;
  discountedPrice: number;
  lowOnStock?: boolean;
  item: Item | undefined;
  metaData?: MetaData;
  itemId?: number;
  itemName?: string;
  itemPrice?: number;
  showOnMenu?: boolean;
  hasModifier?: boolean;
  itemPicture?: string;
  stockStatus?: string;
  preparationTime?: string | null;
}
export interface MetaData {
  id: number;
  tag: Tag[];
  addOns?: any[];
  allergen: Allergen[];
  calories: any;
  itemName: string;
  pictures: any[];
  itemPrice: number;
  isDiscount: boolean;
  totalLikes: number;
  itemPicture: string;
  stockStatus: string;
  totalReviews: number;
  itemDescription: string;
  orderedQuantity: number;
  preparationTime: string;
  selectedModifierGroups?: SelectedModifier[];
  discountPercentage: number;
  optionalModifierGroups?: ModifierGroup[] | null;
  requiredModifierGroups?: ModifierGroup[] | null;
  instructions?: string;
}
export interface Tag {
  id: number;
  tagName: string;
  image: string;
  iconId: number;
}

export interface Allergen {
  id: number;
  allergenName: string;
}

export interface SelectedModifier {
  id: number;
  isNested?: boolean;
  priority: number;
  groupName: string;
  isGeneric: boolean;
  modifiers?: IModifier[];
  subgroups: any[];
  isOptional: boolean;
  maxSelector?: number;
  minSelector?: number;
  multiSelect: boolean;
}
export interface RestaurantCategory {
  id: number;
  categoryName: string;
}

export interface Menu {
  id: number;
  menuName: string;
  categories: RestaurantCategory[];
  startTimeLocal?: string;
  endTimeLocal?: string;
  endTime?: any;
  startTime?: any;
}

export interface RestaurantInfo {
  id: number;
  name: string;
  address: string;
  image: string | null;
  bannerImage: string | null;
  onlineOrder: boolean;
  reviews: any[]; // You can replace `any` with an appropriate type for reviews
  restaurantTimings: RestaurantTiming[]; // You can replace `any` with an appropriate type for timings
  menus: Menu[];
  onlineOrderingSettings: OnlineOrderingSetting;
  giftCardSettings: GiftCardSettings[];
  financialConfigurations?: RestaurantFinancialConfiguration | null;
  status?: string;
  cuisineType: string | null;
  accountId: string;
  description?: string;
  restaurantAlias: string;
  data: {
    restaurant: {
      status: string;
    };
  };
  isLoyaltyEnabled: boolean;
  mobileBanner: string | null;
  latitude: number;
  longitude: number;
  phoneNo: string;
  orderSchedulingEnabled?: boolean;
  scheduleOrderingHours?: string;
  scheduleDays?: number;
  scheduleInterval?: number;
  businessId: number;
  business: Business;
  generalSettings: [GeneralSettings];
  metaPixelId?: string | null;
  kitchenHubInfo: KitchenHubInfo[] | null;
  giftCard: GiftCardTemplate[];
}
export interface KitchenHubInfo {
  kitchenHubStoreId: string;
  partnerName: string;
  integrationAccountId: string;

  deliveryEnabled?: boolean;
  testMode?: boolean;
  autoCancelTimeInMinutes?: number;
  deliveryRadius?: number;
}

export interface GeneralSettings {
  orderDelay: number;
}

export interface RestaurantResponse {
  data: {
    restaurant: RestaurantInfo;
    priceLimits: priceLimits;
    averageRating: number;
    totalReviews: number;
    userPoints?: number;
  };
}

export interface RestaurantReviews {
  id: number;
  review: string;
  status: string;
  rating: number;
  createdAt: string;
  updatedAt: string;
  user: {
    id: string;
    firstName: string;
    lastName: string;
    fullName: string;
    phoneNumber: string;
    emailAddress: string;
  };
  restaurant: {
    id: number;
    name: string;
    address: string;
    image: string;
    phoneNo: string;
  };
  response: {
    content: string;
  };
  username?: string;
}

export interface PaginationMeta {
  totalItems: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
  hasNextPage: boolean;
}
export interface RestaurantReviewsResponse {
  data: {
    reviews: RestaurantReviews[];
    meta: PaginationMeta;
  };
}

export interface OnlineOrderingSetting {
  isPickupEnabled?: boolean;
  specialRequestsOnItems: false;
  specialRequestsOnOrder: false;
  enableScheduledOrders: boolean;
  enableOnlineOrdering: boolean;
  enableSingleModifierView: boolean;
  hideOutOfStockItems: boolean;
  enablePaylater?: boolean;
  qrDineInEnabled?: boolean;
  qrTakeawayEnabled?: boolean;
  hideTimeBasedMenuItems?: boolean;
  enableQROrdering?: boolean;
  useBusinessHoursForPickup?: boolean;
  usePickUpHoursForScheduled?: boolean;
  defaultQROrderingType?: DefaultQROrderingType;
}
export interface priceLimits {
  maxPrice: string | number;
  minPrice: string | number;
  restaurantId?: number;
}
export interface CategoryItemData {
  data: CategoryItem[];
}
export interface CategoryItem {
  id: number;
  itemName: string;
  itemPrice: number;
  // allergens?: AllergenDialogMenu[];
  actualPrice?: number;
  discountedPrice?: number;
  isDiscount: boolean;
  showOnMenu: boolean;
  hasModifier: boolean;
  itemPicture: string;
  onlineImage: string;
  landscapeImage: string;
  stockStatus: any;
  preparationTime: string;
  discountPercentage: number;
  startTime?: string | null;
  endTime?: string | null;
  orderedQuantity?: number;
  minLimit?: number;
  maxLimit?: number;
  noMaxLimit?: boolean;
  categoryId: number;
  menuId: number;
  outOfStockRequiredModifiers?: boolean;
  visibility?: ItemVisibility;
  settingId: number;
  itemDescription: string;
  calories: number;
  quantity: number;
  sortOrder: number;
  showOnline: boolean;
  showPOS: boolean;
  showQR: boolean;
  showThirdParty: boolean;
  posName: string;
  kdsName: string;
  createdAt: string;
  updatedAt: string;
  // modifierGroup: ModifierGroup[];
  // modifiers: IModifier[];
  tags: number[];
  allergens: number[];
  modifiers: any;
  totalReviews: number;
  taxRate: number;
  isSpecialRequest: boolean;
  isSettingsVisible?: boolean;
  selectedModifierGroups?: ModifierGroup[];
  optionalModifierGroups?: ModifierGroup[] | null;
  requiredModifierGroups?: ModifierGroup[] | null;
  item?: Item;
  loyaltyId?: number;
  loyaltyName?: string;
  loyaltyTier?: number;
  category?: Category[];
  taxAmount?: number;
  totalLikes: number;
  isVisible?: boolean;
  saleCategory?: string;
}

export interface ItemVisibility {
  isDefault: boolean;
  schedules: Record<WeekDay, ItemVisibilitySchedule>;
}

export interface ItemVisibilitySchedule {
  day: WeekDay;
  endTime: string | null;
  startTime: string | null;
  availabilityType: 'AllDay' | 'PartialDay';
}

export interface CategoryMenuItems {
  items: CategoryItem[];
  category: Category;
}

export interface CategoryItemResponse {
  data: CategoryItem[];
  success: boolean;
  message: string;
  error: null | string;
}
export interface User {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  emailAddress: string | null;
  imgUrl: string | null;
  restaurantId: number;
  createdAt: string;
  updatedAt: string;
}
export interface Bookmarkresponse {
  id: number;
  createdAt: string;
  updatedAt: string;
  user: User;
  itemId: number;
  item: any; // Replace 'any' with the appropriate type if needed
  restaurant: Restaurant;
}

export interface Submodifier {
  id: number;
  limit: number;
  price: number;
  isNested: boolean;
  isGeneric: boolean;
  isOptional: boolean;
  multiSelect: boolean;
  modifierName: string;
  submodifiers: Submodifier[];
}

// export interface ModifierGroup {
//   id: number;
//   isNested: boolean;
//   priority: number;
//   groupName: string;
//   prefix: string | null;
//   isGeneric: boolean;
//   modifiers: IModifier[];
//   subgroups: ModifierGroup[];
//   isOptional: boolean;
//   maxSelector: number;
//   minSelector: number;
//   multiSelect: boolean;
// }

export interface AddOn {
  id: number;
  itemName: string;
  itemPicture: string;
  itemPrice: number;
  isDiscount: boolean;
  discountPercentage: number;
  orderedQuantity: number;
  stockStatus: boolean;
}

export interface Review {
  id: number;
  review: string;
  status: string | null;
  rating: number | null;
  createdAt: string;
  updatedAt: string;
  user: User;
  username?: string;
}
export interface LatLng {
  address: string;
  latitude: number;
  longitude: number;
  id: number; // Assuming id is a string, adjust the type accordingly
  name: string;
  phoneNo: string;
}

export interface SingleFilteredItem {
  itemId: number;
  itemName: string;
  itemPrice: number;
  isDiscount: boolean;
  showOnMenu: boolean;
  itemPicture: string;
  stockStatus: string;
  preparationTime: string | null;
  discountPercentage: number;
}

export interface MenuItems {
  categoryId: number;
  categoryName: string;
  items: CategoryItem[];
}

export interface FilterModalProps {
  tags: ItemTag[];
  allergens: ItemAllergen[];
  priceLimits: priceLimits | undefined;
}

export interface RestaurantTimingSlot {
  id: number;
  startTime: string | null;
  endTime: string | null;
  createdAt: string;
  updatedAt: string;
}
export interface RestaurantTiming {
  id: number;
  day: string;
  status: 'open' | 'closed';
  type: string;
  startTime: string | null;
  endTime: string | null;
  createdAt: string;
  updatedAt: string;
  cognitoCreatedAt?: string;
  cognitoUpdatedAt?: string | null;
  cognitoCreatedBy?: string;
  cognitoUpdatedBy?: string | null;
  restaurantId: number;
  selectedPickupDeliveryDate?: string;
  slots: RestaurantTimingSlot[];
}

export interface NearbyRestaurant {
  id: number;
  duration: string;
  name: string;
  latitude: number;
  longitude: number;
  address: string;
  status: string;
  distance: number | string;
  distanceValue: number;
  phoneNo: string;
  restaurantTimings: RestaurantTiming[];
  autoFire?: boolean;
  autoFireTimer?: number | object;
  onlineOrderTimer?: object | null;
  image?: string;
  accountId?: string;
  businessId?: number;
  onlineOrderingSettings: OnlineOrderingSetting;
  isLoyaltyEnabled?: boolean;
  orderSchedulingEnabled?: boolean;
  scheduleInterval?: number;
  scheduleDays?: number;
  scheduleOrderingHours?: string;
  scheduleOrderFireTime?: number | null;
  isPickupEnabled?: boolean;
  restaurantAlias?: string;
  reviews?: number;
  averageRating: number;
  priceLimits: priceLimits;
  bannerImage?: string | null;
  mobileBanner?: string | null;
  description?: string;
  onlineOrder?: boolean;
  business?: Business;
  generalSettings?: [GeneralSettings];
  financialConfigurations?: RestaurantFinancialConfiguration | null;
  cuisineType?: string | null;
  avgPrepTime?: number;
  kitchenHubInfo?: KitchenHubInfo[] | null;
  durationValue?: number; //in minutes
  estimated_delivery_time?: number;
}

export interface NearbyRestaurants {
  [restaurantId: string]: { restaurant: NearbyRestaurant };
}

export interface MenuPageDataType {
  categories: Category[];
  items: MenuItems[];
  menus: StoreMenu[];
  restaurant: RestaurantInfo;
  reviews: number;
  timings: RestaurantTiming[];
  priceLimits: priceLimits;
  averageRating: number;
  userPoints: number;
  restaurantLoyalty: boolean;
  giftCardsAvailable: boolean;
  filterAllergens: any;
  filterTags: any;
  visibilitySettings?: VisibilitySettings;
  itemByMenu?: ItemByMenu;
  itemAddOns: AddOns;
  menuVersion: string;
  menuName: string;
}

export interface HomeRestaurant {
  restaurant: RestaurantInfo;
  reviews: number;
  timings: RestaurantTiming[];
  priceLimits: priceLimits;
  averageRating: number;
  userPoints: number;
  restaurantLoyalty: boolean;
  giftCardsAvailable: boolean;
}

export enum BookmarkType {
  Restaurant = 'restaurant',
  Item = 'item',
}

export enum CategoryNameType {
  Popular = 'Popular Items',
  favorite = 'Favorite Items',
}

export interface SuggestedItem {
  itemId: number;
  itemName: string;
  itemPrice: string;
  itemPicture: string;
  isDiscount: boolean;
  discountPercentage: string;
  stockStatus: 'true' | 'false';
  showOnMenu: boolean;
  preparationTime: string;
  ticketcount: string;
  hasModifier: boolean;
}

export interface DealStore {
  deal?: IDealDataResponse;
  items?: CartItem[];
  dealItemType?: string;
  dealId?: number;
  discountedPrice?: number;
  originalPrice?: number;
}

export interface CartStore {
  cart: Cart;
  cartOptions: CartOptions;
  reorder?: boolean;
  items?: any;
  cartType?: string;
  itemSync?: boolean;
  error?: any;
}

export interface FilterStore {
  selectedTags?: number[];
  tags?: number[];
  selectedAllergens?: number[];
  allergens?: number[];
  filterPrice?: number[];
  cookingTime?: FilterPrepareTime;
  filterPopup?: boolean;
  searchVal?: string;
  isSearch?: boolean;
  AllergensSelection?: boolean;
  noSearchItem?: boolean;
  menuId?: number;
}
export interface FilterPrepareTime {
  value: number | '';
  maxValue?: boolean;
  minValue?: boolean;
}
export interface CartOptions {
  isCartEnabled?: boolean;
  isCartUpdated?: boolean;
  isCartLoading?: boolean;
  selectedCartItem?: number;
  reorder?: boolean;
  items?: any;
  cart?: any;
  error?: any;
}
export interface ActiveRestaurant {
  businessId: number;
  businessAlias: string;
  restaurantId: number;
  restaurantAlias: string;
}
export interface Cart {
  id?: number;
  items: CartItem[];
  orderedQuantity?: number;
  quantity?: number;
  actualPrice?: number;
  totalBill: number;
  discountedPrice?: number | undefined;
  totalTax?: number;
  tipAmount?: number;
  tipPercentage?: number;
  platformFee?: number;
  deliveryFeeInDollars?: number;
  deliveryPickupDate?: Date | string;
  address?: string;
  apartment?: string;
  city?: string;
  state?: string;
  street?: string;
  zipCode?: number;
  latitude?: number;
  longitude?: number;
  order_type: OrderType;
  orderSource: OrderSource;
  includeUtensils?: boolean;
  note?: string;
  businessId: number;
  restaurantId?: number;
  restaurantName?: string;
  estimatedTimeSlotId: number;
  customerUsername?: string;
  estimatedTimeSlot?: estimatedTimeObj;
  customer?: customerDataResponse;
  location?: LocationRequestType;
  resturantAddress?: NearbyRestaurant;
  restaurant?: NearbyRestaurant;
  onlineOrderingSettings?: OnlineOrderingSetting;
  order?: OrderDataType;
  createdAt?: string;
  updatedAt?: string;
  orderStatus?: string;
  pickupTime?: string;
  delayTime?: number;
  guestSessionId?: string;
  accountId?: string;
  paymentInfo?: PaymentInfo;
  itemOutStock?: boolean;
  modifierOutStock?: boolean;
  showOutStockError?: boolean;
  itemsUnavailable?: boolean;
  cartType?: string;
  itemSync?: boolean;
  reorder?: boolean;
  cart?: Cart;
  userPoints?: number;
  restaurantLoyalty?: boolean;
  pointsUsed?: number;
  isDealAvailable?: boolean;
  deliveryStatus?: string;
  tableId?: number;
  tableNumber?: number;
  activeRestaurant?: ActiveRestaurant | undefined;
  giftCardsAvailable?: boolean;
  is_gift_card_applied?: boolean;
  user_gift_card_id?: number;
  giftCardAmount?: number;
  giftCard?: UserGiftCard;
  error?: any;
  nuggetId?: string;
  financialConfigurations?: RestaurantFinancialConfiguration | null;
  dealId?: number;
  deal?: IDealDataResponse;
  priceToBeUpdate?: number;
  tableNo?: string;
  lastAdded?: Date | string;
}
export interface CartItem {
  id: number;
  cart_item_id?: number;
  itemId?: number;
  itemPrice: number;
  actualPrice?: number;
  orderedQuantity: number;
  isDiscount: boolean;
  discountPercentage: number;
  discountedPrice?: number;
  originalPrice?: number;
  special_instructions?: string;
  specialRequest?: string;
  tag?: ItemTag[];
  allergen?: ItemAllergen[];
  optionalModifierGroups?: ModifierGroup[];
  requiredModifierGroups?: ModifierGroup[];
  selectedModifierGroups: ModifierGroup[];
  addOns?: CartAddOns[];
  itemName: string;
  itemDescription: string;
  itemPicture: string | null;
  onlineImage: string;
  landscapeImage: string;
  calories: number;
  quantity: number;
  preparationTime: string;
  stockStatus: string;
  sortOrder: number;
  showOnMenu: boolean;
  showOnline: boolean;
  showPOS: boolean;
  showQR: boolean;
  showThirdParty: boolean;
  posName: string;
  kdsName: string;
  createdAt: string;
  updatedAt: string;
  modifierGroup?: ModifierGroup[];
  modifiers: IModifier[];
  pictures?: Pictures[];
  totalLikes: number;
  totalReviews: number;
  hasModifier?: boolean;
  paymentInfo?: PaymentInfo;
  item?: Item;
  reorder?: boolean;
  items?: Item[];
  cart?: Cart;
  cartType?: string;
  itemSync?: boolean;
  itemIndex?: number;
  minLimit?: number;
  maxLimit?: number;
  noMaxLimit?: boolean;
  isSettingsVisible?: boolean;
  isLoyaltyApplied?: boolean;
  loyaltyAmountApplied?: number;
  error?: any;
  dealId?: number;
  dealItemType?: string;
  deal?: IDealDataResponse;
  settingId?: number;
  visibility?: ItemVisibility;
  tags?: number[];
  allergens?: number[];
  isVisible?: boolean;
  categoryId: number;
  menuId: number;
}
export interface CartAddOns {
  id: number;
  itemName: string;
  itemPicture: string;
  itemPrice: number;
  isDiscount: boolean;
  discountPercentage: number;
  orderedQuantity: number;
  stockStatus: boolean | null;
}
export interface ModifierGroupData {
  addOns: CartAddOns[];
  itemId: number;
  optionalModifierGroups: ModifierGroup[] | undefined;
  requiredModifierGroups: ModifierGroup[] | undefined;
}

type IncrementActionData = {
  item: CartItem;
  index: number;
};
type DecrementActionData = {
  item: CartItem;
  index: number;
  quantity: number;
};

export type CartReducerAction = {
  type: CartReducerActionType;
  data?: CartStore | Cart | CartResponseFields | CartItem | CartOptions | null | undefined;
};

export enum CartReducerActionType {
  SyncCart = 'syncCart',
  SaveAndSyncCart = 'saveAndSyncCart',
  SyncLocalCart = 'syncLocalCart',
  Reset = 'reset',
  SetState = 'setState',
  AddToCart = 'addToCart',
  RemoveFromCart = 'removeFromCart',
  UpdateInCart = 'updateToCart',
  IncrementInCart = 'incrementQuantityInCart',
  DecrementInCart = 'decrementQuantityInCart',
  incrementCartItem = 'incrementCartItem',
  SaveCart = 'saveCart',
  DeleteItem = 'deleteItem',
  ReorderItems = 'reorderItems',
  ToggleCartOption = 'toggleCartOption',
  AddDealItems = 'addDealItems',
  RemoveDealItems = 'removeDealItems',
  CheckDecrementPricing = 'checkDecrementPricing',
  CheckDeletePricing = 'checkDeletePricing',
  CheckUpdatePricing = 'checkUpdatePricing',
}

export type CartActionTypes =
  | CartStore
  | Cart
  | CartResponseFields
  | CartItem
  | CartOptions
  | null
  | undefined
  | IncrementActionData
  | DecrementActionData;

export interface UpdateCartItemModel {
  id?: number;
  tipAmount: number;
  tipPercentage: number;
  includeUtensils?: boolean;
  note?: string;
  discountedPrice?: number;
  totalBill?: number;
  order_type?: string;
  isScheduledOrder?: boolean;
  scheduledDateTime?: any;
  is_gift_card_applied?: boolean;
  user_gift_card_id?: number | null;
  giftCardAmount?: number | null;
  giftCard?: UserGiftCard | null;
  deliveryFeeInDollars?: number;
}
export interface CartResponseFields {
  customerUsername?: string;
  deliveryFeeInDollars?: number;
  items?: CartItem[];
  orderedQuantity?: number;
  quantity?: number;
  actualPrice?: number;
  totalBill?: number;
  discountedPrice?: number | undefined;
  discountPercentage?: number;
  tipAmount?: number;
  tipPercentage?: number;
  id?: number;
  index?: number | undefined;
  itemName?: string;
  itemPrice?: number;
  isDiscount?: boolean;
  showOnMenu?: boolean;
  hasModifier?: boolean;
  itemPicture?: string;
  stockStatus?: 'TRUE' | 'FALSE';
  preparationTime?: string | null;
  optionalModifierGroups?: ModifierGroup[] | undefined;
  requiredModifierGroups?: ModifierGroup[] | undefined;
  selectedModifierGroups?: ModifierGroup[] | undefined;
  addOns?: CartAddOns[];
  resturantAddress?: NearbyRestaurant;
  onlineOrderingSettings?: OnlineOrderingSetting;
  financialConfigurations?: RestaurantFinancialConfiguration | null;
  businessId?: number;
  accountId?: string;
  order?: OrderDataType;
  reorder?: boolean;
  cart?: Cart;
  cartType?: string;
  itemSync?: boolean;
  updatedItem?: CartItem;
  oldCartItem?: CartItem;
  userPoints?: number;
  restaurantLoyalty?: boolean;
  isDealAvailable?: boolean;
  pointsUsed?: number;
  order_type?: string;
  orderSource?: string;
  giftCardsAvailable?: boolean;
  is_gift_card_applied?: boolean;
  user_gift_card_id?: number;
  giftCardAmount?: number;
  giftCard?: UserGiftCard;
  paymentInfo?: any;
  error?: any;
  deal?: IDealDataResponse;
  dealItems?: CartItem[];
  dealIds?: number[];
  dealId?: number;
  priceToBeUpdate?: number;
  actionType?: CartReducerActionType;
  itemIndex?: number;
  lastAdded?: Date | string;
  restaurantId?: number;
  guestSessionId?: string;
}
export interface GuestFormValues {
  username?: string;
  // firstName: string;
  // lastName: string;

  name: string;
  email?: string;
  phoneNumber: string;
  restaurantId?: number;
}

export interface RestaurantReview {
  rating: number;
  review?: string;
  itemReviews?: ItemReviews[];
  username?: string;
}
export interface ItemReviews {
  itemId: number;
  review?: string;
  isLiked?: boolean;
}
export interface DirectionsResult {
  routes: Array<{
    legs: Array<{
      distance: {
        text: number;
      };
    }>;
  }>;
}
export interface DirectionsStatus {
  INVALID_REQUEST: string;
  MAX_WAYPOINTS_EXCEEDED: string;
  NOT_FOUND: string;
  OK: string;
  OVER_QUERY_LIMIT: string;
  REQUEST_DENIED: string;
  UNKNOWN_ERROR: string;
  ZERO_RESULTS: string;
}
export interface CustomWindow extends Window {
  google: any;
}

export interface latAndLng {
  lat: number;
  lng: number;
}
export interface OrderResponseType {
  id: number;
  status?: string;
  note?: string;
  noOfGuests?: number;
  createdAt?: string;
  updatedAt?: string;
  tickets?: TicketDataResponse[];
  carts?: Cart[];
}

export interface MyOrdersResponseType {
  id: number;
  dealId?: number;
  status?: string;
  note?: string;
  noOfGuests?: number;
  createdAt?: string;
  updatedAt?: string;
  ticketNumber?: number;
  paymentInfo?: PaymentInfo;
  payment?: PaymentType[];
  isNotificationSent?: string;
  location: ILocation;
  order: OrderDataType;
  customer: ICustomer;
  restaurant: Restaurant;
  ticketItems: OnlineTicketItemType[];
  ticketPaymentStatus: TicketPaymentStatus;
  orderStatus?: string;
  orderSource?: OrderSource;
  orderType?: string;
  doordash?: IDoordash;
  qrId?: number;
  table?: Table;
  review?: Review;
  isScheduledOrder?: boolean;
  scheduledDateTime?: string;
  is_gift_card_applied?: boolean;
  restaurantId: number;
  cartId: number;
}

export interface IDoordash {
  externalDeliveryId: string;

  // Nullable fields
  currency?: string;
  deliveryStatus?: string;
  fee?: number;
  pickupBusinessName?: string;
  pickupExternalBusinessId?: string;
  pickupExternalStoreId?: string;
  dropoffLocation?: {
    lat: number;
    lng: number;
  };
  dropoffContactGivenName?: string;
  dropoffContactFamilyName?: string;
  orderValue?: number;
  tip?: number;
  updatedAt?: Date;
  createdAt?: Date;
  deliveryCreationTime?: Date;
  pickupTimeEstimated?: Date;
  dropoffTimeEstimated?: Date;
  trackingUrl?: string;
  contactlessDropoff?: boolean;
  actionIfUndeliverable?: string;
  dropoffRequiresSignature?: boolean;
  dropoffCashOnDelivery?: number;

  // Required fields
  pickupAddress: string;
  businessId: string;
  pickupPhoneNumber: string;
  dropoffAddress: string;
  dropoffPhoneNumber: string;
}

export interface ICustomer {
  id: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  phoneNumber: string;
  emailAddress?: string;
  emailVerifiedAt?: Date | null;
  isSubscribed?: boolean;
  imgUrl?: string;
  isLoginAllowed: boolean;
  isVip: boolean;
  birthday: Date;
  address: string;

  // Timestamps
  createdAt: Date;
  updatedAt: Date;
  restaurantCustomers?: RestaurantCustomer[];
}

export interface OrderstatusData {
  id: number;
  orderStatus?: string;
  pickupTime?: string;
  deliveryStatus?: string;
  deliveryDetails?: string;
  delayTime?: string;
}
export interface TappedModifierData {
  modifierId?: number;
  optionId?: number;
  optionName?: string;
  nestedId?: number;
  nestedName?: string;
}
export interface PriceObj {
  value: number;
}

export interface ReceiptPayload {
  receiptType: string;
  restaurantId: number;
  mobileNumber?: string;
  email?: string;
  customerName?: string;
  customerId?: string;
}

export interface CartPointsType {
  title: string;
  value: number;
  tooltip: string;
  isAvailable: boolean;
}
export interface CreateDeliveryPayload {
  external_delivery_id: string;
  pickup_address: string;
  pickup_phone_number: string;
  pickup_business_name: string;
  dropoff_address: string;
  dropoff_phone_number: string;
  dropoff_contact_given_name: string;
  pickup_reference_tag: number;
}

export enum TipConfigType {
  Total = 'total',
  Subtotal = 'subtotal',
}

export interface TipSettings {
  suggestedTips: SuggestedTip[];
  areTipsEnabled: boolean;
  customTipEnabled: boolean;
  tipConfigurationPaymentType: 'paid_daily' | 'paid_weekly' | 'paid_monthly' | string; // adjust if needed
}

export interface SuggestedTip {
  order: number;
  value: number;
  isDefault: boolean;
}

export interface TicketItem {
  id: number;
  item: CategoryItem;
  price: number;
  metaData: MetaData;
  quantity: number;
  paymentInfo: TicketPaymentInfo;
  categoryId?: number;
  menuId?: number;
}

export interface MetaData {
  modifierGroup: any[]; // or a more specific interface if you have one
  selectedModifier: any[]; // same here
}

export interface TicketPaymentInfo {
  discount: number;
  totalTax: number;
  actualTax: number;
  totalBill: number;
  actualPrice: number;
  discountedPrice: number;
  totalServiceCharge: number;
  gratuityChargesAmount: number;
  itemLevelDealDiscount: number;
  totalServiceChargeTaxAmount: number;
  nonRevenueinReportChargesAmount: number;
}

export interface IcustomDelivery {
  tipAmount: number;
  iscustomDeliveryTip: boolean;
}

export interface DeliveryOrder {
  order_id: string;
  scheduled_order?: boolean;

  customer_info: {
    first_name: string;
    last_name: string;
    phone_number: string;
  };
  drop_off_info: {
    drop_off_address: string;
    drop_off_datetime: string | null;
    drop_off_notes: string;
  };

  charges: {
    total: number;
    delivery_tips: number;
  };
}

export interface GiftCardTemplate {
  id: number;
  images: string[];
}
